import { tabNames } from '@va/constants';
import { PageContent } from '@va/dashboard/shared/ui-layout';
import { useActiveTab, usePageHeaderProps } from '@va/dashboard/util-hooks';
import { useRefreshContext } from '@va/util/components';
import { useMemo } from 'react';
import VisitorsByCityCard from './VisitorsByCityCard';
import VisitorsByCountryCard from './VisitorsByCountryCard';

export const LocationsTab = () => {
  useActiveTab(tabNames.latestVisitorsLocations);
  const { manualRefresh } = useRefreshContext();

  const pageHeaderProps = useMemo(() => ({ refreshFn: () => manualRefresh() }), [manualRefresh]);

  usePageHeaderProps(pageHeaderProps);

  return (
    <PageContent>
      <div className='space-y-7'>
        <VisitorsByCountryCard />
        <VisitorsByCityCard />
      </div>
    </PageContent>
  );
};
